<div class="missing-products-sheet">
  <div class="header">
    <h3>
      {{ translationService.getMissingProductsForYearTitleText() }}
    </h3>
    <button mat-icon-button type="button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  @if (loading) {
    <div class="body body--center">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="32"
      ></mat-progress-spinner>
    </div>
  }

  @if (!loading && error) {
    <div class="body body--error">
      <p>{{ error }}</p>
    </div>
  }

  @if (!loading && !error && summary) {
    <div class="body">
      <p class="summary">
        {{
          translationService.getMissingProductsSummaryText(
            summary.missingCount,
            summary.totalEligible
          )
        }}
      </p>
      @if (summary.missingCount === 0) {
        <div class="empty">
          <p>
            {{ translationService.getAllEligibleProductsAlreadyInReportText() }}
          </p>
        </div>
      }
      @if (summary.missingCount > 0) {
        <div class="list">
          <div class="list-header">
            <span class="col col--sku">
              {{ translationService.getSkuText() }}
            </span>
            <span class="col col--name">
              {{ translationService.getProductNameText() }}
            </span>
            <span class="col col--supplier">
              {{ translationService.getSupplierText() }}
            </span>
            <span class="col col--material">
              {{ translationService.getMaterialTypeText() }}
            </span>
            <span class="col col--year">
              {{ translationService.getReportingYearLabelText() }}
            </span>
          </div>
          @for (p of summary.products; track p) {
            <div class="row">
              <span class="col col--sku">{{ p.sku }}</span>
              <span class="col col--name">{{ p.articleName }}</span>
              <span class="col col--supplier">{{ p.supplier || '—' }}</span>
              <span class="col col--material">{{ p.materialType || '—' }}</span>
              <span class="col col--year">
                {{ p.reportingDate ? (p.reportingDate | date: 'yyyy') : '—' }}
              </span>
            </div>
          }
        </div>
      }
    </div>
  }

  <mat-divider></mat-divider>

  <div class="actions">
    <button mat-stroked-button type="button" (click)="onClose()">
      {{ translationService.getCloseText() }}
    </button>

    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onImportMissing()"
      [disabled]="loading || hydrating || !hasMissing"
    >
      {{
        hydrating
          ? translationService.getAddingMissingProductsText()
          : translationService.getAddMissingProductsToReportText()
      }}
    </button>
  </div>
</div>
